import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { CoordsButton } from "../Components/CoordsButton";
import { EvidenciaItem } from "../Components/EvidenciaItem";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import RemoveCircleTwoToneIcon from "@mui/icons-material/RemoveCircleTwoTone";
import { useState } from "react";
import {
  addEspaceCharacters,
  constantes,
  instance,
} from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { useLocation } from "react-router-dom";
import { LoaderBox } from "../Components/LoaderBox";
import CloseIcon from "@mui/icons-material/Close";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";

function SeguimientoAgregar() {
  const { state } = useLocation();
  const { id } = state;
  const [coords, setCoords] = useState();
  const [evidencias, setEvidencias] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [descripcion, setDescripcion] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [mes, setMes] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [addCoords, setAddCoords] = useState(false);
  const { user } = useAuth();
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Categoria",
    pageState: {},
  });

  if (isLoading) {
    async function getItems() {
      try {
        const { data } = await instance.get(`/unidad/listByActividad/${id}`);
        setUnidades(data);
      } catch (error) {
        alert(error);
      }
    }
    getItems();
    setLoading(false);
  }
  function agregarEvidencia() {
    setEvidencias((current) => [...current, { unidad: "", cantidad: 0 }]);
  }
  function eliminarEvidencia() {
    setEvidencias([...evidencias.slice(0, evidencias.length - 1)]);
  }
  function changeUnidades(index, e) {
    unidades[index].reportado = e.target.value;
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = new FormData();
    form.append("actividad", id);
    form.append("id", user.id);
    form.append("mes", mes.Id);
    form.append("ejecutado", info.ejecutado.value);
    form.append("descripcion", addEspaceCharacters(descripcion));
    form.append(
      "coordenadas",
      addCoords ? addEspaceCharacters(info.coordenadas.value) : "No especifica."
    );
    form.append("unidades", JSON.stringify(unidades));
    for (const file of evidencias.map((archivo) => {
      return archivo.file;
    })) {
      form.append("archivo", file);
    }
    form.append(
      "evidencias",
      JSON.stringify(
        evidencias.map((archivo) => {
          return {
            tipo: archivo.tipo,
            descripcion: archivo.descripcion,
          };
        })
      )
    );
    instance
      .post("seguimiento/", form)
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: "El seguimiento ha sido registrado exitosamente.",
          redirect: true,
          page: "/Actividad",
          pageState: { id: id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxWidth="lg"
        sx={{ border: { xs: "0", sm: "1px solid #000" }, mt: 2 }}
      >
        <Grid
          container
          spacing={3}
          padding={2}
          rowSpacing={1}
          component="form"
          onSubmit={handleSubmit}
        >
          <Grid item xs={12} sm={6}>
            <DropDownList
              required
              title="Mes de ingreso"
              endpoint={`/seguimiento/getRegisteredMonths/${id}`}
              selectedItem={mes}
              setSelectedItem={setMes}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="ejecutado"
              name="ejecutado"
              label="Ejecutado en el mes"
              type="number"
              inputProps={{
                step: constantes.decimales_dinero,
                min: 0,
                style: { textAlign: "right" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Q</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="descripcion"
              label="Descripción"
              name="descripcion"
              multiline
              onChange={(e) => setDescripcion(e.target.value)}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: addCoords ? "block" : "none" }}
          >
            <TextField
              margin="normal"
              required={addCoords}
              fullWidth
              id="coordenadas"
              label="Coordenadas"
              name="coordenadas"
              value={coords}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setCoords(e.target.value)}
            />
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <CoordsButton
                title="Obtener ubicación actual"
                color="primary"
                output={setCoords}
              />
              <IconButton
                variant="contained"
                color="error"
                onClick={() => setAddCoords(false)}
                sx={{}}
              >
                <Tooltip title="Cerrar agregar coordenadas">
                  <CloseIcon />
                </Tooltip>
              </IconButton>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: addCoords ? "none" : "flex",
            }}
          >
            <IconButton
              variant="contained"
              color="success"
              onClick={() => setAddCoords(true)}
              size="small"
            >
              <Tooltip title='Si no se agregan se guardará como "No especifica"'>
                <span>
                  <AddLocationAltIcon fontSize="large" />
                  Agregar coordenadas
                </span>
              </Tooltip>
            </IconButton>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography sx={{ margin: 0 }} component="p">
              Reporte de unidades
            </Typography>
            {unidades.map(function (item, index) {
              return (
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  type="number"
                  id={"unidad" + index}
                  name={"unidad" + index}
                  label={item.nombre}
                  InputLabelProps={{ shrink: true }}
                  key={index}
                  variant="standard"
                  size="small"
                  inputProps={{
                    step: constantes.decimales_unidades,
                    min: 0,
                    style: { textAlign: "right" },
                  }}
                  onChange={(e) => changeUnidades(index, e)}
                />
              );
            })}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}>
              {evidencias.map((evidencia, index) => {
                return (
                  <>
                    <EvidenciaItem
                      key={index}
                      changes={index}
                      evidencias={evidencias}
                      setevidencias={setEvidencias}
                    />
                    <Divider />
                  </>
                );
              })}
            </Box>
            <IconButton
              color="success"
              sx={{ borderRadius: "0" }}
              onClick={() => agregarEvidencia()}
            >
              <AddCircleTwoToneIcon />
              <Typography sx={{ margin: 0 }} component="p">
                Agregar evidencia
              </Typography>
            </IconButton>
            <IconButton
              color="error"
              sx={{ borderRadius: "0" }}
              onClick={() => eliminarEvidencia()}
              disabled={!(evidencias.length > 0)}
            >
              <RemoveCircleTwoToneIcon />
              <Typography sx={{ margin: 0 }} component="p">
                Eliminar evidencia
              </Typography>
            </IconButton>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Box>
              <Button
                type="submit"
                variant="contained"
                color="success"
                sx={{ mt: 3, mb: 2 }}
                padding={1}
              >
                Agregar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { SeguimientoAgregar };
